import styled from 'styled-components'

export const RadioInput = styled.input.attrs((_props) => ({
  type: 'radio'
}))``
